import i18n from 'i18n';
import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';
import { timeFromNow, isDateToday } from 'utils/dateHelpers';

import { useFetchStatus } from 'utils/fetchStatusUtils';

export const MESSAGE_TYPES = {
  video: 'video',
  text: 'text',
  bid: 'bid',
};

export default new Presenter(
  {
    uid: PropTypes.string,
    chatUid: PropTypes.string,
    senderId: PropTypes.number,
    type: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
    createdAt: PropTypes.number,
    videoLoadingStatus: PropTypes.string,
    videoUrl: PropTypes.string,
  },
  {
    formatedSentTimeFromNow(message) {
      return timeFromNow(this.createdAt(message));
    },
    isVideoMessage(message) {
      return this.type(message) === MESSAGE_TYPES.video;
    },
    isBidMessage(message) {
      return this.type(message) === MESSAGE_TYPES.bid;
    },
    isVideoPrepearing(message) {
      return useFetchStatus(this.videoLoadingStatus(message)).isPending;
    },
    text(message) {
      if (this.isVideoMessage(message)) {
        return i18n.t(`presenters.MessagePresenter.sentAVideo`);
      }
      if (this.isBidMessage(message)) {
        return i18n.t(`presenters.MessagePresenter.sendABid`);
      }

      return this.data(message);
    },
    isSentToday(message) {
      const createdAt = this.createdAt(message);
      return isDateToday(createdAt);
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/MessagePresenter.js